import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { localDateKey } from './dateKey';

export type AiQuotaSlot = { used: number; limit: number; remaining: number };

export type AiQuotaSnapshot = {
  dateKey: string;
  unlimited?: boolean;
  mealSearches: AiQuotaSlot;
  coachMessages: AiQuotaSlot;
  formChecks: AiQuotaSlot;
};

export async function fetchAiDailyQuota(): Promise<AiQuotaSnapshot> {
  return api<AiQuotaSnapshot>(`/api/ai/daily-quota?dateKey=${encodeURIComponent(localDateKey())}`);
}

export function useAiDailyQuota(enabled: boolean) {
  const [quota, setQuota] = useState<AiQuotaSnapshot | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      setQuota(await fetchAiDailyQuota());
    } catch {
      /* paywall / offline */
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { quota, refresh, setQuota };
}
